var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('el-link',{staticStyle:{"text-align":"left","font-size":"24px"},attrs:{"href":_vm.refUrl,"target":"_blank","type":"primary"}},[_c('i',{staticClass:"el-icon-link"}),_vm._v("打开链接")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd8daa8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionLayoutExtralPageNoFrame.vue
// module id = null
// module chunks = 